// THE LISTING: the site's published posts, newest first, a page at a time.
//
// Gen-2's `blog-list` had an empty configuration — page size, sort and filter
// were all unreachable from the editor, and its cursor was forward-only. These
// four fields are what it lacked. The page NUMBER comes from the route
// (`/blog/page/:page?` supplies `params.page`), not from here, because a page
// is an address. Under a literal segment, because `/blog/:page?` beside a post
// page at `/blog/:slug` is two patterns of one shape and the older page wins
// — see docs/pagews-blog.md §4.
//
// `postRoute` is the pattern of the page that shows one post, so every item
// can carry a `url` the template links to. It defaults to the convention and
// is a field because nothing else on a page knows which OTHER page is the
// post page.
//
// The template is the site's list template (`site.blog.templates.list`), not
// a field here — see @common/schema/site/blog.
export const schema = [
  {
    id: "/Page/Element/Type/BlogList",
    type: "object",
    properties: {
      limit: {
        label: "Posts per page",
        type: "number",
        minimum: 1,
        maximum: 100,
        default: 10,
      },
      tag: {
        label: "Only posts tagged",
        type: "string",
        default: "",
      },
      postRoute: {
        label: "Post page route",
        $ref: "/Page/Route",
        default: "/blog/:slug",
      },
    },
    required: [],
  },
];
